<template>
       <div class="page">
         <div class="d-flex justify-space-between">
         <h2 class="main-title">{{title}}</h2>
         <v-btn @click="addItems()" color="error">Добавить</v-btn>
      </div>
         <v-data-table
            class="table table-white table-search"
            :headers="headers"
            :items="listSpeciality"
            :loading="loadingTable"
            loading-text="Данные загружаются..."
            :search="search"
            :footer-props="{
            'pageText': '{0}-{1} из {2}',
            'items-per-page-text':'Количество строк на странице'
        }"
        >
            <template v-slot:header>
               <div class="search" >
                  <v-text-field
                    style="background: #B6DFF0 url(/img/search.28af04cd.svg) no-repeat 7px 50%; padding-left: 30px; margin-top: 0px; padding-top: 0px;padding-left: 5px"
                    v-model="search"
                    single-line
                    hide-details
                />
               </div>
            </template>
            <template v-slot:[`header.name`]>
                 <span style="color: #003C69;">Название</span>
            </template>
            <template v-slot:item="{ item }">
                <tr>
                    <td>
                     <div class="d-flex justify-space-between">
                        <span style="width: 90%;">
                           {{ item.name }}
                        </span>
                        <div>
                           <v-btn small icon color="primary" >
                        <img svg-inline @click="editeItems(item)" :src="require('@/assets/icon/Pencil.svg')" />
                     </v-btn>
                     <v-btn small icon color="error">
                        <img svg-inline @click="deleteItems(item)" :src="require('@/assets/icon/Trash.svg')" />
                     </v-btn>
                        </div>
                     </div>

                    </td>
                </tr>
            </template>
            <v-progress-linear :active="loadingTable" :indeterminate="loadingTable" absolute bottom color="primary accent-4" ></v-progress-linear>
            </v-data-table>
            <v-dialog v-model="dialog" max-width="600px" persistent>
        <div class="d-flex justify-end">
        </div>
          <v-card>
                  <div style=" padding: 20px 0 0 30px; display: flex; ">
                    <h2 class="header" style="width: 85%;">{{titleDialog}} специальностей</h2>
                    <v-btn icon style="margin: 2px 0 0 5px" class="close" @click="close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                           <path d="M6 5L18.7279 17.7279" stroke="#1976d2" stroke-width="2" stroke-linecap="round"/>
                           <path d="M6 18L18.7279 5.27208" stroke="#1976d2" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                     </v-btn>
                  </div>

              <v-card-text class="pb-0">
                  <v-container>
                      <v-form v-model="valid" ref="form" lazy-validation>
                          <v-row>
                              <v-col cols="12" sm="12" md="12">
                                  <h3 class="title-font">Наименование</h3>
                                  <v-text-field class="title-font" :rules="[rules.required]" dense outlined v-model="obj.name" />
                              </v-col>
                          </v-row>
                      </v-form>
                  </v-container>
              </v-card-text>

              <v-card-actions class="pb-5 mr-4 d-flex justify-end">
                <button  class="ma-2 btn-add" outlined  @click="close">Отменить</button>
                  <button class="btn" :loading="saveLoading" @click="save(obj)">Сохранить</button>
              </v-card-actions>
          </v-card>
      </v-dialog>
    </div>
 </template>

 <script>
import {mapGetters, mapActions, mapMutations} from 'vuex'

   export default {
     name: 'Manual',
     watch:{
      search(val){
        this.update(val ? val : '');
      }
     },
     data () {
       return {
         title: 'Специальности',
         headers: [
           {text: 'Название', value: 'name', input: '', search: true, align: "center" },
         ],
         pagination: {
            sortBy: 'name'
        },
        page: 1,
        snackbar: false,
        snackbar_text: '',
        snackbarColor: '',
        itemsPerPage: 10,
        listSpeciality: [],
        saveLoading: false,
        loadingTable: false,
        obj:{
         name: ''
        },
        params: {
                filters: [],
                sortOption: {
                    fieldName: 'name',
                    sortType: 2
                },
                pageSize: 10,
                currentPage: 0,
                useANDoperator: false,
                columns: []
            },
            search: '',
            dialog: false,
            titleDialog : '',
            valid: '',
            rules: {
               required: (v, text) => !!v || (text ? text : 'Обязательно для заполнения.')
            }
       }
     },
     computed : {
       ...mapGetters({
           getСatalog: 'catalog/getСatalog',
           apiUrl: 'apiUrl'
       }),
     },
     methods: {
       ...mapActions({
         catalog: 'catalog/catalog',
       }),
       ...mapMutations({
         setSearch: 'catalog/setSearch'
       }),
       loadSpeciality(filters){
        this.$http.post(`${this.apiUrl}Profile/GetAll`,{
         columns: this.params.columns,
        sortOption: this.params.sortOption,
        currentPage: this.params.currentPage,
        filters: filters,
        pageSize: this.params.pageSize,
        useANDoperator: this.params.useANDoperator
         })
         .then((res) => {
            this.listSpeciality = res.data.data
            this.loadingTable = false;
         })
       },
       update(value){
         this.params.filters = []
         this.params.filters.push( {
            fieldName: 'name',
            filterType: 2,
            filterValueType: 1,
            value1: value,
         });
         this.loadSpeciality(this.params.filters)
       },
       close() {
          this.$refs.form.resetValidation();
          this.edite = false;
          this.obj = { name: '' };
          this.saveLoading = false;
          this.dialog = false;
      },
       addItems() {
          this.titleDialog = 'Добавление'
          this.dialog = true
      },
       editeItems(item){
          this.edite = true;
          this.titleDialog = 'Редактирование'
          this.obj = Object.assign({}, item);
          this.dialog = true
      },
      save(obj) {
          if(this.$refs.form.validate()) {
              this.saveLoading = true;
              if(this.edite) {
                  this.$http.post(`${this.apiUrl}Profile/Update`, {
                      id: obj.id,
                      name: obj.name,
                  })
                  .then((res) => {
                      for (let i = 0; i < this.listSpeciality.length; i++) {
                          if(this.listSpeciality[i].id === res.data.id) {
                              Object.assign(this.listSpeciality[i], res.data);
                          }
                      }
                      this.close();
                  })
                  .catch((error) => {
                    if(error){
                        this.snackBarFunc(true, 'Запись с таким именем уже существует', 'warning')
                        }
                    })
              } else {
                  this.$http.post(`${this.apiUrl}Profile/Add`, {
                      name: obj.name,
                  })
                  .then((res) => {
                      this.listSpeciality.unshift(res.data);
                      this.close();
                  })
                  .catch((error) => {
                    if(error){
                        this.snackBarFunc(true, 'Запись с таким именем уже существует', 'warning')
                    }
                    })
              }
          } else {
              this.snackBarFunc(true, 'Заполните обязательные поля!!!', 'warning')
          }
      },
      deleteItems(item){
          if(confirm('Вы уверены, что хотите удалить значение?')) {
              this.$http.post(`${this.apiUrl}Profile/Delete?id=${item.id}`, {})
              .then(() => {
                  let index = this.listSpeciality.findIndex((f) => f.id === item.id);
                  this.listSpeciality.splice(index, 1);
              });
          }
      },
       sortArray(array, name) {
      return array.sort((a, b) => {
        if (a[name] < b[name]) {
          return -1;
        }

        if (a[name] > b[name]) {
          return 1;
        }

        return 0;
      })
    },
    snackBarFunc(flag, text, color) {
        this.snackbar = flag
        this.snackbar_text = text
        this.snackbarColor = color
    },
     },
     created(){
         this.loadSpeciality([])
     }

   }
 </script>
 <style lang="scss" scoped>
.btn {
    padding: 6px 12px;
        border-radius: 4px;
        background: #3E5F71;
        color: #FFF;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
  }
  .svg {
      position: absolute;
      top: 30px;
      right: 10px;
    }
    .btn-add {
        padding: 6px 12px;
        border-radius: 4px;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        white-space: nowrap;
        border: 2px solid #3E5F71;
        color: #3E5F71 !important;
}
 </style>
